export default [
  { path: '/km', 
    name: 'KMList', 
    component: () => import('@/views/km/Index'),
    meta: {
      breadcrumbs: [
        { text: 'ระบบจัดการความรู้' }
      ]
    }
  },
  { 
    path: '/km/create', 
    name: 'KMCreate', 
    component: () => import('@/views/km/Form'), 
    meta: { 
      form_type: 'CREATE',
      form_title: 'เขียน',
      breadcrumbs: [
        { text: 'ระบบจัดการความรู้', to: `/km` },
        { text: `เขียนบทความ` },
      ]
    }, 
  },
  { 
    path: '/km/:id/edit', 
    name: 'KMEdit', 
    component: () => import('@/views/km/Form'), 
    meta: { 
      form_type: 'EDIT',
      form_title: 'แก้ไข',
      breadcrumbs: [
        { text: 'ระบบจัดการความรู้', to: `/km` },
        { text: `แก้ไขบทความ` },
      ]
    }, 
  },
]